import { createFileRoute } from "@tanstack/react-router";

import { TicketDetailPane } from "@/components/ticket/ticket-detail-pane";

function TicketDetailRoute() {
  const { ticketId } = Route.useParams();
  return <TicketDetailPane ticketId={ticketId} />;
}

export const Route = createFileRoute("/_auth/tickets/$ticketId")({
  component: TicketDetailRoute,
});
